import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';

//获得公司列表
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true)
}

//获得自产/代加工
export async function getScorderList(params) {
    return post(erpserver+'/scorder/getScorderList', params, true)
}


